export const noticeInitData: NoticeRegisterType = {
  needModifyData: true,
  currentCategory: 1301000,
  title: "",
  contents: "",
  stores: [],
  beforeStores: [],
  tempStores: [],
  deleteTempStore: [],
  dateToggle: false,
  endDate: "",
  importNotice: false,
  fileList: [],
  imageList: [],
  limitImage: 3,
};

export const category = [
  { value: "1301000", name: "일반공지" },
  { value: "1302000", name: "마네킨 착장" },
  { value: "1303000", name: "매장연출" },
  { value: "1304000", name: "영상" },
  { value: "1305000", name: "비주얼" },
  { value: "1306000", name: "기타" },
];

// 공지 첨부파일 - 개당 용량 상한 및 개수 상한.
//
// 용량은 개당 500MB 를 유지한다. ITSM-43679 는 5GB 로 올려 달라고 요청했으나, 실제
// 배포 파일을 실측한 결과 상한에 걸린 적이 없었다. 매장에 배포하는 영상은 매장
// 디스플레이 규격으로 인코딩한 것이라 단일 파일 최대가 63.7MB 이고, 캠페인 1회분
// 전체를 합쳐도 약 916MB 다. 공지 첨부 이력의 최대값도 2023년 PDF 497.1MB 이고
// 영상은 2026년 기준 평균 22.5MB 다. 상한이 실제 최대 파일의 약 8배이므로 용량이
// 막고 있던 것이 아니다.
//
// 막고 있던 것은 개수다. 캠페인 1회분은 같은 영상을 기기 규격별로 다시 인코딩한
// 23-25개 파일로 이루어지는데 상한이 7개였다. 그래서 개수만 올린다.
//
// 100 은 업무상 필요치가 아니라 안전장치다. 실측 최대가 25개이므로 정상 사용은
// 여기에 닿지 않는다. 그래서 화면 안내에 개수를 적지 않는다. 숫자를 알리면 100개를
// 채워도 되는 한도로 읽히고, 닿았다는 것 자체가 예상 밖의 사용이라는 신호이므로
// 안내 문구 대신 ITSM 접수로 보낸다.
export const NOTICE_ATTACH_MAX_SIZE = 500 * 1000 ** 2;
export const NOTICE_ATTACH_MAX_COUNT = 100;
// 화면에 보이는 모든 용량 표기가 NOTICE_ATTACH_MAX_SIZE 와 같이 움직이도록 라벨도 한 곳에 둔다.
export const NOTICE_ATTACH_MAX_SIZE_LABEL = "500MB";
export const NOTICE_ATTACH_MAX_SIZE_MESSAGE = `파일 용량은 개당 ${NOTICE_ATTACH_MAX_SIZE_LABEL}를 초과할 수 없습니다.`;
// 개수 상한은 안전장치이므로 숫자를 노출하지 않는다. 닿은 사용자는 ITSM 으로 보낸다.
export const NOTICE_ATTACH_MAX_COUNT_MESSAGE = "첨부 가능한 파일 개수를 초과했습니다.\n첨부가 더 필요하면 ITSM 으로 요청해 주세요.";
// 개수를 적지 않는다. 위 주석의 안전장치 설명 참고.
export const NOTICE_ATTACH_GUIDE_MESSAGE = `* 파일은 개당 ${NOTICE_ATTACH_MAX_SIZE_LABEL} 이하 첨부 가능하며, 이미지 첨부는 화면의 상단 영역에서만 가능합니다.`;

// 이행매장 엑셀 업로드 - 파일 크기 제한 (서버 413 기준과 동일)
export const EXCEL_UPLOAD_MAX_SIZE = 5 * 1024 * 1024;
export const EXCEL_UPLOAD_SIZE_MESSAGE = "파일은 5MB 이하만 올릴 수 있습니다";
// accept=".xlsx" 는 선택창 필터일 뿐이므로 확장자를 한 번 더 검사한다. 문구는 서버 400 응답과 동일하게 유지.
export const EXCEL_UPLOAD_TYPE_MESSAGE = "지원하지 않는 파일 형식입니다. .xlsx 파일만 업로드할 수 있습니다.";
export const isExcelUploadFile = (fileName: string): boolean => /\.xlsx$/i.test(fileName);

// 이행매장 엑셀 업로드 - 매칭 실패 사유 한글 문구
export const EXCEL_UNMATCHED_REASON_LABEL: Record<ExcelUnmatchedReason, string> = {
  NOT_FOUND: "영업 중인 내 브랜드 매장에 없음",
  DUPLICATE: "파일 내 중복 (첫 행만 선택됨)",
  AMBIGUOUS: "동일 매장명이 여럿 (매장코드 필요)",
  EMPTY: "매장명·매장코드 모두 비어 있음",
};

// 이행매장 엑셀 업로드 - 엑셀 인식 규칙 안내 문구 (검증은 서버가 수행, 프론트는 안내만)
export const EXCEL_UPLOAD_GUIDE = [
  "헤더 인식: 매장명 · 매장코드 · 점포명 · 점포코드 · store name · store code · store id",
  "이름 · 코드 · name · code · id 같은 단독 단어 헤더는 인식되지 않습니다.",
  "헤더가 있으면 컬럼 순서 무관, 없으면 1열 매장명 · 2열 매장코드로 읽습니다.",
  "매장코드는 콤마·공백·대소문자를, 매장명은 앞뒤·연속 공백과 대소문자를 무시합니다.",
  "매장 데이터는 최대 5,000행, 빈 행 포함 20,000행에 닿으면 거부됩니다.",
  ".xlsx 파일 1개, 5MB 이하만 업로드할 수 있습니다.",
];

// ===== 이행평가 피드백 엑셀 업로드 (VMD-389) =====
export const EXECUTE_FEEDBACK_UNMATCHED_REASON_LABEL: Record<ExecuteFeedbackUnmatchedReason, string> = {
  EMPTY_CODE: "매장코드 없음",
  NOT_IN_NOTICE: "이 공지의 이행 매장 아님",
  NOT_EXECUTED: "아직 이행하지 않은 매장",
};
// 판정이 빈 행의 표시 문구 (서버 값은 빈 문자열)
export const EXECUTE_FEEDBACK_EMPTY_VERDICT_LABEL = "(판정 없음)";
// 기본 선택에서 빼고 안내 문구를 붙이는 판정. 평가 규칙 미비로도 생기므로 매장 잘못과 구분할 수 없다.
export const EXECUTE_FEEDBACK_CAUTION_VERDICTS: Record<string, string> = {
  미확인: "사진 상태 불량뿐 아니라 평가 규칙 미비로도 생기는 판정입니다. 매장에 촬영 보완 요청으로 전달되니 확인 후 선택하세요.",
};
export const EXECUTE_FEEDBACK_GUIDE = [
  "앱 업로드용 DATA_UPLOAD 시트의 1행 헤더, 2행부터 데이터를 읽습니다.",
  "매장코드(필수)로 매칭합니다. 매장명은 확인용이며 매칭에 쓰지 않습니다. 대소문자도 그대로 비교합니다.",
  "매장코드가 ALL 인 행은 전 매장 공통 피드백으로 각 매장 코멘트 맨 위에 붙습니다.",
  "선택한 판정의 행만 매장당 코멘트 1건으로 등록되고 평가완료로 표시됩니다. 별점은 바뀌지 않습니다.",
  "같은 공지에 다시 올리면 파일에 들어온 매장의 기존 피드백 코멘트를 교체합니다.",
];
